import { Box } from "@mui/material";
import React from "react";

export default function SubSection({ children }) {
  return <Box sx={{ pt: 2 }}>{children}</Box>;
}
